import { render, staticRenderFns } from "./MainLedgerCreate.vue?vue&type=template&id=ca7c9bc4&scoped=true"
import script from "./MainLedgerCreate.vue?vue&type=script&lang=js"
export * from "./MainLedgerCreate.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerCreate.vue?vue&type=style&index=0&id=ca7c9bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7c9bc4",
  null
  
)

export default component.exports